import {clsx} from 'clsx'
import type {ComponentProps} from 'react'

import styles from './placeholder.module.css'

type PlaceholderSizeProps = {
  minWidth: number
  maxWidth: number
}

type PlaceholderDivProps = PlaceholderSizeProps & ComponentProps<'div'> & {ref?: React.Ref<HTMLDivElement>}

export const TextPlaceholder = ({ref, className, minWidth, maxWidth, style, ...props}: PlaceholderDivProps) => (
  <div
    ref={ref}
    className={clsx(styles.TextPlaceHolder, styles.shimmerAnimation, className)}
    style={{
      // eslint-disable-next-line react-hooks/purity
      '--placeholder-width': `${minWidth + Math.floor(Math.random() * (maxWidth - minWidth))}px`,
      minWidth: `${minWidth}px`,
      maxWidth: `${maxWidth}px`,
      ...style,
    }}
    {...props}
  />
)
TextPlaceholder.displayName = 'TextPlaceholder'

export const PillPlaceholder = ({ref, className, minWidth, maxWidth, style, ...props}: PlaceholderDivProps) => (
  <div
    ref={ref}
    className={clsx(styles.PillPlaceholder, styles.shimmerAnimation, className)}
    style={{
      // eslint-disable-next-line react-hooks/purity
      '--placeholder-width': `${minWidth + Math.floor(Math.random() * (maxWidth - minWidth))}px`,
      minWidth: `${minWidth}px`,
      maxWidth: `${maxWidth}px`,
      ...style,
    }}
    {...props}
  />
)
PillPlaceholder.displayName = 'PillPlaceholder'

export const AvatarPlaceholder = ({
  ref,
  className,
  ...props
}: ComponentProps<'div'> & {ref?: React.Ref<HTMLDivElement>}) => (
  <div className={clsx(styles.AvatarPlaceholder, styles.shimmerAnimation, className)} {...props} ref={ref} />
)
AvatarPlaceholder.displayName = 'AvatarPlaceholder'
